import { useEffect, useState } from "react"
import { InputAdornment, List, ListSubheader, Stack, Table, TableBody, Typography, useTheme } from "@mui/material"

import { Bound } from "lib/@components/binding/Bound"
import { DialogBox } from "lib/@components/dialogBox"
import Iconify from "minimals-template/components/Iconify"
import { setFromEvent } from "lib/setFromEvent"
import { BlockKeyboard } from "lib/@components/block-clicks"
import { DebouncedTextField } from "lib/@components/debounced-text-field"
import { RequestPageRepeat } from "lib/@components/request-page-repeat"
import { AuthoringUserRow } from "authoring/users/authoring-user-row"
import { Frag } from "lib/@components/slot/frag"
import { getUsersAllocatableToProject } from "authoring/users/controller/get-users-allocatable-to-project"

export function AddContactDialog({ projectId }) {
    const [skip, setSkip] = useState(0)
    const [take, setTake] = useState(15)
    const [search, setSearch] = useState("")
    const theme = useTheme()
    const allocatableUsers = getUsersAllocatableToProject.useResults({
        projectId,
        searchTerm: search,
        skip,
        take,
    })
    const [selected, setSelected] = useState()

    useEffect(() => {
        setSelected(undefined)
    }, [search])

    if (!allocatableUsers) return null

    const { users, total } = allocatableUsers

    return (
        <Bound selected={selected} setSelected={setSelected}>
            <DialogBox sx={{ minHeight: "55vh", maxHeight: "55vh" }} title="Add User to Work Package" value={selected}>
                <Stack spacing={2} sx={{ mt: 2 }} data-cy="add-contact-dialog">
                    <BlockKeyboard>
                        <DebouncedTextField
                            autoFocus
                            fullWidth
                            maxRows={5}
                            multiline
                            size="small"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Iconify icon="material-symbols:search" />
                                    </InputAdornment>
                                ),
                            }}
                            value={search}
                            onChange={setFromEvent(setSearch)}
                            variant="outlined"
                            placeholder="Enter Name or Email Address"
                        />
                    </BlockKeyboard>
                    <List>
                        <ListSubheader
                            disableSticky
                            sx={{ ...theme.typography.overline, bgcolor: "#0001", py: 1, mb: 2 }}
                        >
                            Existing Users
                        </ListSubheader>

                        {total === 0 && (
                            <Typography variant="body2" sx={{ color: "text.secondary", py: 1, px: 2 }}>
                                No contacts // invite
                            </Typography>
                        )}
                        <Table size="small">
                            <TableBody>
                                <RequestPageRepeat
                                    pageSize={take}
                                    setSkip={setSkip}
                                    total={total}
                                    list={users}
                                    setTake={setTake}
                                    item={
                                        <AuthoringUserRow
                                            roleSelector={false}
                                            onSelectRow={setSelected}
                                            selected={selected}
                                        />
                                    }
                                    ContentWrapper={Frag}
                                />
                            </TableBody>
                        </Table>
                    </List>
                </Stack>
            </DialogBox>
        </Bound>
    )
}
